import React from "react";

export const RequiredBadge = () => {
    return <span className="bg-cyan-400 text-white text-xs font-bold py-1 px-1">必須</span>
}